import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SaveIcon from '@material-ui/icons/Save';

import { useFormularioContext } from '../../commons/Formulario';
import { confirmacion, mensaje, mensajeMini } from '../../commons/Mensajes';

import Boton from '../../commons/Boton';
import Loading from '../../commons/Loading';
import Tabla from '../../commons/Tabla';

import useMantenimiento from '../../hooks/useMantenimiento';

const MaintenanceSupplies = ({ equipment, previusEquipment, onSave }) => {
  const { selected, accionTask } = useFormularioContext();
  const { postMaintenanceSupplies } = useMantenimiento();

  const [supplies, setSupplies] = useState([]);
  const [used, setUsed] = useState([]);
  const [process, setProcess] = useState(false);

  useEffect(() => {
    let res = [];
    selected.nn.map((x) => {
      res.push({
        id: x.mt.cm,
        mt: x.mt.mt,
        nm: x.mt.nm,
        um: x.mt.du,
        un: x.ia,
        iu: x.iu,
        in: x.in,
        ct: 0,
      });
    });
    setSupplies(res);
    setUsed(
      previusEquipment.in.map((x) => {
        return {
          id: x.mt.cm,
          mt: x.mt.mt,
          nm: x.mt.nm,
          ct: x.ct,
        };
      })
    );
  }, []);

  const handleSaveSupplies = async () => {
    setProcess(true);
    let response = await postMaintenanceSupplies({
      eq: equipment.eq.eq,
      ia: accionTask,
      so: selected.so,
      li: supplies.map((x) => ({ mt: x.mt, ct: x.ct })),
    });
    if (response.success && response.status === 'success') {
      mensaje('Operación Satisfactoria');
      onSave();
    } else if (response.messageError) {
      mensajeMini(response.messageError);
    } else if (response.fieldsErrors) {
      mensajeMini(Object.values(response.fieldsErrors)[0]);
    }
    setProcess(false);
  };

  /**
   * Actualizar cantidad de insumo a usar.
   * @param {string} id identificador de insumo
   * @param {number} valor cantidad a usar
   */
  const handleEditarCantidad = (id, valor) => {
    setSupplies(
      supplies.map((x) =>
        x.id === id
          ? {
              ...x,
              ct: valor < 0 ? 0 : valor,
            }
          : x
      )
    );
  };

  const columnsSupplies = [
    {
      key: 'id',
      label: 'Código',
    },
    {
      key: 'nm',
      label: 'Insumo',
    },
    {
      key: 'um',
      label: 'Unidad medida',
    },
    {
      key: 'un',
      align: 'center',
      label: 'Asignados',
    },
    {
      key: 'ct',
      align: 'center',
      label: 'Usar',
      hide: previusEquipment?.fa ? true : false,
      content: (item) => (
        <div className="op-centrar-componentes">
          <div className={`cantidad edit`}>
            <input
              type="number"
              value={item.ct}
              style={{ fontSize: '14px', padding: '4px' }}
              onChange={(e) => handleEditarCantidad(item.id, e.target.value)}
            />
          </div>
        </div>
      ),
    },
  ];
  const columnsUsed = [
    {
      key: 'id',
      label: 'Código',
    },
    {
      key: 'nm',
      label: 'Insumo',
    },
    {
      key: 'ct',
      align: 'center',
      label: 'Usados',
    },
  ];

  return (
    <div>
      {process && <Loading tipo={'request'} />}
      <h3>Insumos asignados</h3>
      <Tabla
        columns={columnsSupplies}
        data={supplies}
        searcheable={false}
        pagination={false}
        hoverSelectedRow={false}
        emptyRowsMessage="Ning&uacute;n insumo asignado"
        style={{ padding: 0 }}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <h3>Insumos usados</h3>
        {previusEquipment?.fa ? (
          <div></div>
        ) : (
          <Boton
            className="op-grabar"
            icon={() => <SaveIcon />}
            onClick={() =>
              confirmacion(
                '¿Está seguro?',
                `De usar los insumos en ${equipment.eq.ne}, recuerde que ya no podra volver a enviar esta información`
              )
                .then(() => handleSaveSupplies())
                .catch(() => {})
            }
          >
            Registrar insumos
          </Boton>
        )}
      </div>
      <Tabla
        columns={columnsUsed}
        data={used}
        searcheable={false}
        pagination={false}
        hoverSelectedRow={false}
        emptyRowsMessage="Ninguno"
        style={{ padding: 0 }}
      />
    </div>
  );
};

MaintenanceSupplies.propTypes = {
  equipment: PropTypes.object,
  previusEquipment: PropTypes.object,
  onSave: PropTypes.func,
};

export default MaintenanceSupplies;
